export const absenceSetsSelector = state => state.absenceSets;
